// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container for the entire layout */
.nav-drawer-container {
    display: flex;
    background-color: rgb(10, 26, 44);
}

.nav-drawer-container .nav-icon,
.nav-drawer-container svg {
    color: #fff;
}

.nav-drawer-container:hover .nav-child-item {
    cursor: pointer;
}

/* Drawer container */
.nav-drawer {
    flex-shrink: 0;
}

/* Styles for the drawer paper */
.nav-drawer-paper {
    box-sizing: border-box;
    overflow-x: hidden;
    height: 100vh;
    /* fixed height */
    transition: width 300ms cubic-bezier(0.4, 0, 0.6, 1);
    background-color: rgb(10, 26, 44) !important;
}

/* Open and closed drawer widths */
.drawer-open {
    width: 270px;
}

.drawer-closed {
    width: 56px;
}

/* Main content container */
.main-content {
    flex-grow: 1;
    transition: margin-left 300ms cubic-bezier(0.4, 0, 0.6, 1);
}

/* Parent list item styles */
.nav-group-item {
    background-color: rgb(10, 26, 44);
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 8px 16px;
    font-size: 14px !important;
    height: 48px;
    box-sizing: border-box;
}

/* Icon container for parent items */
.nav-child-item-icon,
.nav-list-item-icon {
    min-width: 2.5em !important;
    padding-right: 8px;
    background-color: rgb(10, 26, 44);
}

/* Arrow container */
.nav-box-arrow {
    background-color: rgb(10, 26, 44);
    color: #fff;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-left: auto;
}

/* Collapse container for children */
.nav-collapse-list {
    background-color: rgb(10, 26, 44);
}

/* Child list item */
.nav-child-item {
    padding-left: 32px;
    /* similar to pl:4 */
    background-color: rgb(10, 26, 44);
    color: #fff;
    display: flex;
    align-items: center;
    padding: 8px 16px;
    font-size: 14px;
    height: 48px;
}

.nav-group-item:hover,
.nav-child-item:hover {
    background-color: rgb(61, 95, 131);
}

/* Icon container for child items */
.nav-child-item-icon {
    background-color: rgb(10, 26, 44);
    color: #fff;
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
}

.display-name-badge .MuiTypography-root,
.nav-group-item .MuiTypography-root,
.nav-child-item .MuiTypography-root {
    font-size: 14px !important;
    font-family: Gibson-Regular !important;
    color: rgb(187, 200, 209);
    line-height: normal;
}

/* Ensuring consistent font sizing on any text elements */
.nav-group-item,
.nav-child-item,
.nav-box-arrow,
.nav-list-item-icon {
    font-size: 14px;
}

/* Hover effects for list items */
.nav-group-item:hover,
.nav-child-item:hover {
    background-color: rgb(61, 95, 131);
}

/* Update background for icon and arrow containers on hover of their parent list item */
.nav-group-item:hover .nav-list-item-icon,
.nav-group-item:hover .nav-box-arrow,
.nav-child-item:hover .nav-box-arrow,
.nav-child-item:hover .nav-child-item-icon {
    background-color: rgb(61, 95, 131);
}

.display-name-badge {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    background-color: rgb(10, 26, 44);
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    margin-top: auto;
    /* push to bottom if needed */
}

.display-name-avatar {
    background-color: var(--mui-primary-main, #1976d2);
    /* fallback if primary is undefined */
    width: 2.5em !important;
    height: 2.5em !important;
    font-size: 12px !important;
    color: black !important;
}

.display-name-text {
    margin-left: 8px;
    font-size: 14px;
    line-height: 20px;
    font-family: 'Gibson-Regular', sans-serif;
    color: #fff;
    padding-left: 1em;
}

.logout-button-container {
    display: flex;
    align-items: center;
    padding: 8px 16px;
    background-color: rgb(10, 26, 44);
    cursor: pointer;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    /* optional divider */
    margin-top: 8px;
}

.logout-icon-button {
    background-color: rgb(10, 26, 44);
    color: #fff;
    padding: 8px;
}

.logout-icon-button:hover {
    background-color: rgb(61, 95, 131);
}

.logout-text {
    margin-left: 8px;
    font-size: 14px;
    line-height: 20px;
    font-family: 'Gibson-Regular', sans-serif;
    color: #fff;
}

.logout-button-container:hover {
    background-color: rgb(61, 95, 131);
}

.nav-app-title-container {
    display: flex;
    color: white;
    padding: 12px 8px 0;
    font-family: 'Gibson-Regular', sans-serif;
    height: 50px;
    cursor: pointer;
    font-size: 18px;
}

.nav-app-title {
    padding: 0 0 .5em;
}

.nav-app-desc {
    font-size: 12px;
}

.nav-app-text-block {
    margin: 0 .5em;
}

.project_icon_img {
    width: 40px;
    height: 40px;
}

.nav-bottom-group {
    margin-top: auto;
}

.nav-child-item.is-active,
.nav-child-item.is-active .nav-child-item-icon {
    background-color: rgb(61, 95, 131);
    font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/shell/sidenav/style.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;IACI,aAAa;IACb,iCAAiC;AACrC;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA,qBAAqB;AACrB;IACI,cAAc;AAClB;;AAEA,gCAAgC;AAChC;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,oDAAoD;IACpD,4CAA4C;AAChD;;AAEA,kCAAkC;AAClC;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA,2BAA2B;AAC3B;IACI,YAAY;IACZ,0DAA0D;AAC9D;;AAEA,4BAA4B;AAC5B;IACI,iCAAiC;IACjC,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,0BAA0B;IAC1B,YAAY;IACZ,sBAAsB;AAC1B;;AAEA,oCAAoC;AACpC;;IAEI,2BAA2B;IAC3B,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA,oBAAoB;AACpB;IACI,iCAAiC;IACjC,WAAW;IACX,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA,oCAAoC;AACpC;IACI,iCAAiC;AACrC;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,oBAAoB;IACpB,iCAAiC;IACjC,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,YAAY;AAChB;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA,mCAAmC;AACnC;IACI,iCAAiC;IACjC,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;;;IAGI,0BAA0B;IAC1B,sCAAsC;IACtC,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,yDAAyD;AACzD;;;;IAII,eAAe;AACnB;;AAEA,iCAAiC;AACjC;;IAEI,kCAAkC;AACtC;;AAEA,uFAAuF;AACvF;;;;IAII,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,iCAAiC;IACjC,8CAA8C;IAC9C,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,kDAAkD;IAClD,qCAAqC;IACrC,uBAAuB;IACvB,wBAAwB;IACxB,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yCAAyC;IACzC,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,iCAAiC;IACjC,eAAe;IACf,8CAA8C;IAC9C,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,yCAAyC;IACzC,WAAW;AACf;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,yCAAyC;IACzC,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,kCAAkC;IAClC,gBAAgB;AACpB","sourcesContent":["/* Container for the entire layout */\n.nav-drawer-container {\n    display: flex;\n    background-color: rgb(10, 26, 44);\n}\n\n.nav-drawer-container .nav-icon,\n.nav-drawer-container svg {\n    color: #fff;\n}\n\n.nav-drawer-container:hover .nav-child-item {\n    cursor: pointer;\n}\n\n/* Drawer container */\n.nav-drawer {\n    flex-shrink: 0;\n}\n\n/* Styles for the drawer paper */\n.nav-drawer-paper {\n    box-sizing: border-box;\n    overflow-x: hidden;\n    height: 100vh;\n    /* fixed height */\n    transition: width 300ms cubic-bezier(0.4, 0, 0.6, 1);\n    background-color: rgb(10, 26, 44) !important;\n}\n\n/* Open and closed drawer widths */\n.drawer-open {\n    width: 270px;\n}\n\n.drawer-closed {\n    width: 56px;\n}\n\n/* Main content container */\n.main-content {\n    flex-grow: 1;\n    transition: margin-left 300ms cubic-bezier(0.4, 0, 0.6, 1);\n}\n\n/* Parent list item styles */\n.nav-group-item {\n    background-color: rgb(10, 26, 44);\n    color: #fff;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    padding: 8px 16px;\n    font-size: 14px !important;\n    height: 48px;\n    box-sizing: border-box;\n}\n\n/* Icon container for parent items */\n.nav-child-item-icon,\n.nav-list-item-icon {\n    min-width: 2.5em !important;\n    padding-right: 8px;\n    background-color: rgb(10, 26, 44);\n}\n\n/* Arrow container */\n.nav-box-arrow {\n    background-color: rgb(10, 26, 44);\n    color: #fff;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n}\n\n/* Collapse container for children */\n.nav-collapse-list {\n    background-color: rgb(10, 26, 44);\n}\n\n/* Child list item */\n.nav-child-item {\n    padding-left: 32px;\n    /* similar to pl:4 */\n    background-color: rgb(10, 26, 44);\n    color: #fff;\n    display: flex;\n    align-items: center;\n    padding: 8px 16px;\n    font-size: 14px;\n    height: 48px;\n}\n\n.nav-group-item:hover,\n.nav-child-item:hover {\n    background-color: rgb(61, 95, 131);\n}\n\n/* Icon container for child items */\n.nav-child-item-icon {\n    background-color: rgb(10, 26, 44);\n    color: #fff;\n    display: flex;\n    align-items: center;\n    font-size: 14px;\n    line-height: 20px;\n}\n\n.display-name-badge .MuiTypography-root,\n.nav-group-item .MuiTypography-root,\n.nav-child-item .MuiTypography-root {\n    font-size: 14px !important;\n    font-family: Gibson-Regular !important;\n    color: rgb(187, 200, 209);\n    line-height: normal;\n}\n\n/* Ensuring consistent font sizing on any text elements */\n.nav-group-item,\n.nav-child-item,\n.nav-box-arrow,\n.nav-list-item-icon {\n    font-size: 14px;\n}\n\n/* Hover effects for list items */\n.nav-group-item:hover,\n.nav-child-item:hover {\n    background-color: rgb(61, 95, 131);\n}\n\n/* Update background for icon and arrow containers on hover of their parent list item */\n.nav-group-item:hover .nav-list-item-icon,\n.nav-group-item:hover .nav-box-arrow,\n.nav-child-item:hover .nav-box-arrow,\n.nav-child-item:hover .nav-child-item-icon {\n    background-color: rgb(61, 95, 131);\n}\n\n.display-name-badge {\n    display: flex;\n    align-items: center;\n    padding: 8px 16px;\n    background-color: rgb(10, 26, 44);\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n    margin-top: auto;\n    /* push to bottom if needed */\n}\n\n.display-name-avatar {\n    background-color: var(--mui-primary-main, #1976d2);\n    /* fallback if primary is undefined */\n    width: 2.5em !important;\n    height: 2.5em !important;\n    font-size: 12px !important;\n    color: black !important;\n}\n\n.display-name-text {\n    margin-left: 8px;\n    font-size: 14px;\n    line-height: 20px;\n    font-family: 'Gibson-Regular', sans-serif;\n    color: #fff;\n    padding-left: 1em;\n}\n\n.logout-button-container {\n    display: flex;\n    align-items: center;\n    padding: 8px 16px;\n    background-color: rgb(10, 26, 44);\n    cursor: pointer;\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n    /* optional divider */\n    margin-top: 8px;\n}\n\n.logout-icon-button {\n    background-color: rgb(10, 26, 44);\n    color: #fff;\n    padding: 8px;\n}\n\n.logout-icon-button:hover {\n    background-color: rgb(61, 95, 131);\n}\n\n.logout-text {\n    margin-left: 8px;\n    font-size: 14px;\n    line-height: 20px;\n    font-family: 'Gibson-Regular', sans-serif;\n    color: #fff;\n}\n\n.logout-button-container:hover {\n    background-color: rgb(61, 95, 131);\n}\n\n.nav-app-title-container {\n    display: flex;\n    color: white;\n    padding: 12px 8px 0;\n    font-family: 'Gibson-Regular', sans-serif;\n    height: 50px;\n    cursor: pointer;\n    font-size: 18px;\n}\n\n.nav-app-title {\n    padding: 0 0 .5em;\n}\n\n.nav-app-desc {\n    font-size: 12px;\n}\n\n.nav-app-text-block {\n    margin: 0 .5em;\n}\n\n.project_icon_img {\n    width: 40px;\n    height: 40px;\n}\n\n.nav-bottom-group {\n    margin-top: auto;\n}\n\n.nav-child-item.is-active,\n.nav-child-item.is-active .nav-child-item-icon {\n    background-color: rgb(61, 95, 131);\n    font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
